import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import SchemaOrg from '@/components/feature/SchemaOrg';
import { siteInfo, allArticles } from '@/mocks/site-data';

const trustItems = [
  {
    icon: 'ri-shield-check-line',
    title: '信息权威',
    description: '所有内容均基于官方公开信息整理，经过专业团队严格审核，确保准确可靠',
  },
  {
    icon: 'ri-time-line',
    title: '持续更新',
    description: '政策法规和办理流程如有变动，我们将在第一时间更新相关内容，保持时效性',
  },
  {
    icon: 'ri-user-heart-line',
    title: '用户至上',
    description: '以用户需求为中心，内容通俗易懂，帮助每位用户快速找到所需信息',
  },
  {
    icon: 'ri-file-text-line',
    title: '内容全面',
    description: `涵盖 ${allArticles.length} 篇深度文章，覆盖黄本子相关的全部知识领域`,
  },
];

const milestones = [
  { year: '2024', title: '平台创立', description: '黄本子官方指南正式上线，致力于为用户提供权威的信息服务' },
  { year: '2025', title: '内容扩展', description: '文章数量突破30篇，覆盖黄本子的定义、用途、办理、法规等全部领域' },
  { year: '2026', title: '体验升级', description: '平台全面优化阅读体验，新增分类浏览和智能搜索功能' },
];

export default function AboutPage() {
  return (
    <>
      <SchemaOrg type="about" />
      <Navbar />
      <main className="pt-16 md:pt-18">
        <section className="py-14 md:py-16 bg-background-100">
          <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
            <nav className="flex items-center gap-2 text-xs text-foreground-400 mb-8">
              <Link to="/" className="hover:text-primary-600 transition-colors">首页</Link>
              <i className="ri-arrow-right-s-line text-xs"></i>
              <span className="text-foreground-700">关于我们</span>
            </nav>

            <div className="max-w-3xl">
              <span className="inline-block px-3 py-1 text-xs font-medium text-primary-700 bg-primary-100 rounded-full mb-4">
                品牌介绍
              </span>
              <h1 className="font-heading text-2xl md:text-4xl font-bold text-foreground-900 mb-4">
                关于 {siteInfo.name}
              </h1>
              <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-3">
                {siteInfo.name}创立于{siteInfo.founded}，是国内最早专注于黄本子知识科普的在线平台之一。{siteInfo.description}
              </p>
              <p className="text-sm md:text-base text-foreground-600 leading-relaxed">
                我们的团队由法律、行政和信息服务领域的专业人员组成，致力于将复杂的官方文件知识转化为通俗易懂的内容，帮助每一位用户轻松理解黄本子的方方面面。
              </p>
            </div>
          </div>
        </section>

        <section className="py-14 md:py-16 bg-background-50">
          <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
            <div className="text-center mb-12">
              <span className="inline-block px-3 py-1 text-xs font-medium text-accent-700 bg-accent-100 rounded-full mb-4">
                品牌信誉
              </span>
              <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-3">
                为什么选择我们
              </h2>
              <p className="text-sm text-foreground-500 max-w-xl mx-auto">
                我们始终坚持高标准的内容质量，为用户提供最可靠的信息服务
              </p>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
              {trustItems.map((item) => (
                <div
                  key={item.title}
                  className="bg-background-50 border border-background-200/70 rounded-lg p-5 md:p-6 text-center"
                >
                  <div className="w-12 h-12 flex items-center justify-center rounded-lg bg-accent-100 text-accent-600 mx-auto mb-4">
                    <i className={`${item.icon} text-xl`}></i>
                  </div>
                  <h3 className="font-heading text-base font-semibold text-foreground-900 mb-2">
                    {item.title}
                  </h3>
                  <p className="text-xs text-foreground-500 leading-relaxed">
                    {item.description}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </section>

        <section className="py-14 md:py-16 bg-background-100">
          <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
            <div className="text-center mb-12">
              <span className="inline-block px-3 py-1 text-xs font-medium text-secondary-700 bg-secondary-100 rounded-full mb-4">
                发展历程
              </span>
              <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-3">
                我们的里程碑
              </h2>
            </div>

            <div className="max-w-2xl mx-auto">
              <div className="relative">
                <div className="absolute left-5 top-0 bottom-0 w-px bg-background-300"></div>
                <div className="flex flex-col gap-8">
                  {milestones.map((m) => (
                    <div key={m.year} className="relative flex items-start gap-6 pl-12">
                      <div className="absolute left-3.5 top-1.5 w-3 h-3 rounded-full bg-accent-500 ring-4 ring-accent-100"></div>
                      <div>
                        <span className="text-xs font-medium text-accent-600">{m.year}</span>
                        <h3 className="font-heading text-base font-semibold text-foreground-900 mt-0.5 mb-1">
                          {m.title}
                        </h3>
                        <p className="text-xs text-foreground-500 leading-relaxed">
                          {m.description}
                        </p>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </section>

        <section id="contact" className="py-14 md:py-16 bg-background-50">
          <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
            <div className="text-center mb-12">
              <span className="inline-block px-3 py-1 text-xs font-medium text-primary-700 bg-primary-100 rounded-full mb-4">
                联系我们
              </span>
              <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-3">
                获取帮助
              </h2>
              <p className="text-sm text-foreground-500 max-w-xl mx-auto">
                如果您对黄本子有任何疑问或建议，欢迎通过以下方式与我们联系
              </p>
            </div>

            <div className="max-w-2xl mx-auto grid grid-cols-1 sm:grid-cols-3 gap-4 md:gap-5">
              <div className="bg-background-50 border border-background-200/70 rounded-lg p-5 text-center">
                <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-accent-100 text-accent-600 mx-auto mb-3">
                  <i className="ri-mail-line text-lg"></i>
                </div>
                <h3 className="text-sm font-semibold text-foreground-800 mb-1">电子邮箱</h3>
                <p className="text-xs text-foreground-500">{siteInfo.email}</p>
              </div>

              <div className="bg-background-50 border border-background-200/70 rounded-lg p-5 text-center">
                <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-accent-100 text-accent-600 mx-auto mb-3">
                  <i className="ri-phone-line text-lg"></i>
                </div>
                <h3 className="text-sm font-semibold text-foreground-800 mb-1">服务热线</h3>
                <p className="text-xs text-foreground-500">{siteInfo.phone}</p>
              </div>

              <div className="bg-background-50 border border-background-200/70 rounded-lg p-5 text-center">
                <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-accent-100 text-accent-600 mx-auto mb-3">
                  <i className="ri-map-pin-line text-lg"></i>
                </div>
                <h3 className="text-sm font-semibold text-foreground-800 mb-1">办公地址</h3>
                <p className="text-xs text-foreground-500">{siteInfo.address}</p>
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
}